import dayjs from "dayjs";

const TREND_WINDOWS = {
    '1d': 7,
    '1w': 4,
    '1M': 3,
    '1q': 4,
    '1y': 3,
}

export const getTrendWindow = (interval) => TREND_WINDOWS[interval] || 3

export const formatHistogramBucket = (timestamp, interval) => {
    const date = dayjs(timestamp)

    switch (interval) {
        case '1d':
        case '1w':
            return date.format('DD.MM.YYYY')
        case '1q':
            return `Q${Math.floor(date.month() / 3) + 1} ${date.format('YYYY')}`
        case '1y':
            return date.format('YYYY')
        case '1M':
        default:
            return date.format('MM.YYYY')
    }
}

export const calculateMovingAverage = (values, period) => {
    const windowSize = Math.max(1, Math.floor(period))

    return values.map((_, index) => {
        if (index < windowSize - 1) {
            return null
        }

        const window = values.slice(index - windowSize + 1, index + 1)
        const sum = window.reduce((total, value) => total + value, 0)

        return Number((sum / windowSize).toFixed(2))
    })
}

export const buildStatsChartOptions = ({
    buckets,
    interval,
    seriesName,
    primaryColor,
    trendColor,
}) => {
    const values = buckets.map((bucket) => Number(bucket.doc_count) || 0)
    const trendWindow = getTrendWindow(interval)
    const series = [
        {
            name: seriesName,
            type: 'bar',
            barMaxWidth: 42,
            data: values,
            itemStyle: {
                borderRadius: [8, 8, 0, 0],
            },
        },
    ]

    if (values.length > trendWindow) {
        series.push({
            name: `Trendlinie (${trendWindow} Perioden)`,
            type: 'line',
            data: calculateMovingAverage(values, trendWindow),
            lineStyle: {
                width: 3,
                type: 'dashed',
            },
            symbol: 'none',
        })
    }

    return {
        color: [primaryColor, trendColor],
        tooltip: {
            trigger: 'axis',
        },
        legend: {
            bottom: 0,
        },
        grid: {
            left: 40,
            right: 20,
            top: 20,
            bottom: 50,
        },
        xAxis: {
            type: 'category',
            data: buckets.map((bucket) => formatHistogramBucket(bucket.key, interval)),
            axisLabel: {
                rotate: buckets.length > 8 ? 30 : 0,
            },
        },
        yAxis: {
            type: 'value',
            min: 0,
            minInterval: 1,
        },
        series,
    }
}
